// src/common/ArrowLeftIcon.jsx
import React from 'react';

// Component for the Back Arrow icon (Lucide React equivalent via inline SVG)
const ArrowLeftIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" fontWeight={900} height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-left">
        <path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>
    </svg>
);

export { ArrowLeftIcon };